// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ql6fYVHw42ZmhB2wjFC8 {
  width: 130px;
  text-align: right;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChemicalComponentDetailModal/index.module.less"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,iBAAA;EACA,qBAAA;AAAF","sourcesContent":["\n.label {\n  width: 130px;\n  text-align: right;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `Ql6fYVHw42ZmhB2wjFC8`
};
export default ___CSS_LOADER_EXPORT___;
